import Util from '../../shared/Util';

export default class RefFriendFormPresenter {
    constructor(
        token, 
        benefitsService,
        updateState, 
        onSave,
        fromList
    ) {
        this.state = {
            name: "",
            lastName: "",
            secondLastName: "",
            email: "",
            formErrors: this.getEmptyFormErrors(),
            isLoading: false,
            token,
            fromList
        };

        this.updateState = updateState;
        this.benefitsService = benefitsService;
        this.onSave = onSave;
    }

    getEmptyFormErrors = () => {
        var emptyFormErrors = {
            name: "",
            lastName: "",
            secondLastName: "",
            email: ""
        };

        return emptyFormErrors;
    }

    onNameChange = ( event ) => {
        this.state.name = event.target.value;
        this.updateState( this.state );
    }

    onLastNameChange = ( event ) => {
        this.state.lastName = event.target.value;
        this.updateState(this.state);
    }

    onSecondLastNameChange = ( event ) => {
        this.state.secondLastName = event.target.value;
        this.updateState(this.state);
    }

    onEmailChange = ( event ) => {
        this.state.email = event.target.value;
        this.updateState(this.state);
    }

    onBackClicked = () => {

        if( this.state.fromList === undefined && window.android ) {
            window.android.back();
        } else if( this.state.fromList === undefined && window.webkit ) {
            window.webkit.messageHandlers.refFriend.postMessage( "back" );
        } else {
            window.location.href = `/listReferences/${this.state.token}`;
        }
    }

    save = async ( event ) => {

        if ( !this.validateForm() ) {
            return false;
        }

        let request = this.makeRequest();
        this.startLoading();
        
        let response = await this.benefitsService.refFriend(this.state.token, request);
        
        if (response) {
            this.onSave(`${this.state.name} ${this.state.lastName} ${this.state.secondLastName}`);
            this.stopLoading();
        }
        return response;
    }

    makeRequest = () => {
        let request = {
            NombreInvitado: this.state.name,
            ApellidoPaternoInvitado: this.state.lastName,
            ApellidoMaternoInvitado: this.state.secondLastName,
            CorreoInvitado: this.state.email
        };
        return request;
    }

    startLoading = () => {
        this.state.isLoading = true;
        this.updateState(this.state);
    }

    stopLoading = () => {
        this.state.isLoading = false;
        this.updateState(this.state);
    }

    validateForm = () => {
        var isValidForm = true;
        this.state.formErrors = this.getEmptyFormErrors();

        if ( this.state.name === "" ) {
            this.state.formErrors.name = "Proporcione el nombre del referenciado";
            this.updateState (this.state);
            isValidForm = false;
        }

        if ( this.state.lastName === "" ) {
            this.state.formErrors.lastName = "Proporcione el apellido paterno";
            this.updateState(this.state);
            isValidForm = false;
        }

        if ( this.state.secondLastName === "" ) {
            this.state.formErrors.secondLastName = "Proporcione el apellido materno";
            this.updateState(this.state);
            isValidForm = false;
        }

        if ( this.state.email === "" || !Util.isEmail(this.state.email) ) {
            this.state.formErrors.email = "Correo no válido";
            this.updateState(this.state);
            isValidForm = false;
        }

        return isValidForm;
    }
}